<template>
  <div class="login">
    
    <div class="con">

      <div class="bm_panel">

        <div class="bmtit">
          <div class="bmt1">学员登陆</div>
        </div>

        <el-form class="ruleForm" :model="ruleForm" :rules="rules" ref="ruleForm1" >

          <el-form-item class="it1" prop="name">
            <el-input v-model="ruleForm.name" prefix-icon="el-icon-user-solid" placeholder="输入账号（预留手机号）"></el-input>
          </el-form-item>

          <el-form-item  class="it2" prop="pass">
            <el-input type="password" v-model="ruleForm.pass" autocomplete="off" prefix-icon="el-icon-lock" placeholder="输入密码"></el-input>
          </el-form-item>

          <el-form-item class="it4" prop="ma">
            <el-input v-model="ruleForm.ma" placeholder="输入验证码"></el-input>
            <img :src="vcdata.img" alt="" @click="fetch_vc">
          </el-form-item>
         
          <el-form-item class="it5">
            <el-button class="submit_btn" type="primary" @click="submitForm('ruleForm1')">登录</el-button>
          </el-form-item>
        </el-form>

      </div>

    </div>

  </div>
</template>
<script>

export default {
  name: 'login',
   data:function () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('账号不能为空'));
      }
      callback();
    };
    var checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('密码不能为空'));
      }
      callback();
    };
    var checkMa = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'));
      }
      callback();
    };

    return {
      vcdata:null,

      ruleForm: {
        name: '',
        pass:'',
        ma:'',
      },

      rules: {
        name: [
          { validator: checkName },
        ],
        pass: [
          { validator: checkPass },
        ],
        ma: [
          { validator: checkMa },
        ],
      },
      
    }
  },
  created(){
    console.log("app created",this.$fly)
    this.fetch();
  },
  methods:{
   async fetch(){
     this.fetch_vc();
   },
   async fetch_vc(){
    let vcdata = await this.$fly.get('/user/verifyCode');
    this.vcdata = vcdata;
    // console.log("vcdata:", this.vcdata);
   },
   submitForm(formName) {
    let self = this;

    this.$refs[formName].validate((valid) => {
      if (valid) {
        let sendObj = {
          username:this.ruleForm.name,
          password:this.ruleForm.pass,
          captcha:this.ruleForm.ma,
          key:this.vcdata.key
        };

        this.$fly.post('/user/login', this.$qs.stringify(sendObj)).then(function (response) {
          if (response === 200) {
            self.$router.push('User');
          }else{
            self.fetch_vc();
          }
        });

      } else {
        console.log('error submit!!');
        // return false;
      }
    });

  },
   onGoHome(){
     this.$router.push('/')
   }
  }
}
</script>

<style lang='scss'>

.login{
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .con{
    width: 100%;
    height: 898px;
    background: url(../assets/bg.png) no-repeat center;

    .bm_panel{
      width: 246px;
      height: 280px;
      position:absolute;
      top:0;
      bottom: 0;
      right:0;
      left: 0;
      margin: auto;
      z-index: 9;
      background-color:#fff;
      border-radius: 10px;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding: 20px;

      .bmtit{
        text-align: center;
        font-size: 20px;
        color: #00B3A4;
        margin-bottom: 20px;

        .bmt2{
          font-size: 10px;
          color: #999999;
          margin: 10px 0;
        }
      }

      .ruleForm{

        .it3{
          .el-icon-s-order{
            position: absolute;
            position: absolute;
            z-index: 1;
            top: 12px;
            left: 10px;
            color: #C0C4CC;
          }

          .el-select{
            width: 100%;

            .el-input__inner{
              padding-left: 30px;
            }

          }
        }

        .it4{
          .el-form-item__content{
            display: flex;
          }
          .el-input{
            width: 50%;
          }

          img{
            width: 103px;
            height: 40px;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
          }
        }

        .it5{
          margin-bottom: 0;
        }

        .submit_btn{
          width: 100%;
        }

      }

    }
  }
}

</style>